import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CannabisRetailerApp from './components/CannabisRetailerApp';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, getDoc, doc } from 'firebase/firestore';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import WorkerDashboard from './components/WorkerDashboard';

function App() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isWorker, setIsWorker] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          // Check user role in Firestore
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setIsAdmin(userData.role === 'admin');
            setIsWorker(userData.role === 'worker');
          }
          
          // For backward compatibility, also check token claims
          const idTokenResult = await currentUser.getIdTokenResult();
          if (idTokenResult.claims.admin) setIsAdmin(true);
          if (idTokenResult.claims.worker) setIsWorker(true);
        } catch (error) {
          console.error('Error checking user role:', error);
        }
        
        setUser(currentUser);
      } else {
        setUser(null);
        setIsAdmin(false);
        setIsWorker(false);
      }
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, [auth, db]);

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Main route - Cannabis Retailer App */}
        <Route path="/" element={<CannabisRetailerApp />} />
        
        {/* Admin Login Route */}
        <Route 
          path="/admin" 
          element={
            isAdmin ? <Navigate to="/admin/dashboard" /> : <AdminLogin />
          } 
        />
        
        {/* Protected Admin Dashboard Route */}
        <Route 
          path="/admin/dashboard/*" 
          element={
            isAdmin ? <AdminDashboard onLogout={() => auth.signOut()} isAdmin={true} /> : 
            <Navigate to="/admin" />
          } 
        />
        
        {/* Worker Dashboard (if needed) */}
        <Route 
          path="/worker" 
          element={
            isWorker ? <WorkerDashboard onLogout={() => auth.signOut()} isWorker={true} user={user} /> : 
            <Navigate to="/" />
          } 
        />
        
        {/* Fallback route - redirects to main page */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;